// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 524) return "css/app.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"96":"fc2055d8782cd8369d7f","241":"58b5ea93cf1d0447f8ec","299":"53deb2929be260d85fcc","626":"35e2b801e607eb0defbb","893":"e5b779d1b2ba91057dc6"}[chunkId] + ".css";
};